module.exports = __webpack_public_path__ + "static/media/oeil.e2c8a98b.svg";